<template>
    <form action="">
        <app-form-text-input
            label="Código"
            v-model="docType.code"
            :has-error="$v.docType.code.$error"
            error-message="Debe escribir el código"
            :required="true"
        />
        <app-form-text-input
            label="Nombre"
            v-model="docType.name"
            :has-error="$v.docType.name.$error"
            error-message="Debe escribir el nombre"
            :required="true"
        />
        <div class="form-group">
            <b-form-checkbox v-model="docType.expiry_date" switch>
                Requiere fecha de vencimiento
            </b-form-checkbox>
        </div>
        <app-form-select-input
            label="Estado"
            v-model="docType.status"
            :options="statusOptions"
            :is-object="false"
        />
    </form>
</template>
<script>
import FormTextInput from '../../UI/Controls/Forms/FormTextInput.vue';
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue';
import contractorDocumentTypesRepository from '../../../repositories/contractor-document-types.repository';
import { required } from 'vuelidate/lib/validators';

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput
    },
    props: {
        selectedType: { type: Object, default: null },
        onSave: { type: Function, default: () => false },
        id: { type: String, default: () => `contractor-document-type-form-${parseInt(Math.random() * 10000000)}` }
    },
    data() {
        return {
            docType: {
                id: '',
                code: '',
                name: '',
                expiry_date: false,
                status: 'active'
            },
            statusOptions: [
                { id: 'active', name: 'Activo' },
                { id: 'inactive', name: 'Inactivo' }
            ]
        };
    },
    watch: {
        selectedType(val) {
            if (val) {
                this.docType = {
                    id: val.id,
                    code: val.code,
                    name: val.name,
                    expiry_date: !!val.expiry_date,
                    status: val.status || 'active'
                };
            }
        }
    },
    validations: {
        docType: {
            code: { required },
            name: { required }
        }
    },
    methods: {
        clear() {
            this.docType = {
                id: '',
                code: '',
                name: '',
                expiry_date: false,
                status: 'active'
            };
            this.$nextTick(() => {
                if (this.$v) this.$v.$reset();
            });
        },
        async saveType() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error('Debe completar los campos obligatorios');
                return;
            }
            try {
                const payload = {
                    code: this.docType.code,
                    name: this.docType.name,
                    expiry_date: !!this.docType.expiry_date,
                    status: this.docType.status
                };
                const response = this.docType.id
                    ? await contractorDocumentTypesRepository.update(this.docType.id, payload)
                    : await contractorDocumentTypesRepository.save(payload);
                const { data } = response;
                if (data.status) {
                    this.clear();
                    toastr.success(data.msg || 'Información guardada satisfactoriamente');
                    this.onSave();
                } else {
                    toastr.error(data.msg || 'Error al guardar el tipo');
                }
            } catch (error) {
                toastr.error('Ocurrió un error al guardar el tipo');
            }
        }
    },
    created() {
        this.$bus.$on('contractor-document-type-form.save', this.saveType);
        this.$bus.$on(`${this.id}.clear`, this.clear);
    },
    beforeDestroy() {
        this.$bus.$off('contractor-document-type-form.save');
        this.$bus.$off(`${this.id}.clear`);
    }
};
</script>
